<script>
import ChLoadingSpinner from 'components/ui/ChLoadingSpinner.vue';

export default {
  components: { ChLoadingSpinner },
  props: {
    message: { type: String, default: '' },
  },
};
</script>

<template>
  <div class="flex items-center justify-center p-8">
    <div class="flex items-center gap-2 text-center">
      <ChLoadingSpinner />
      <span
        v-if="message"
        class="text-sm leading-[22px] font-normal text-gray-gray-17 dark:text-gray-gray-9"
      >
        {{ message }}
      </span>
    </div>
  </div>
</template>
